{
    "PromptDeletereport": "Tem certeza de que deseja remover?",
    "PromptDeletereports": "Tem certeza de que deseja remover permanentemente os relatórios selecionados?",
    "PromptEmptyrecyclebin": "Tem certeza de que deseja remover permanentemente todos os relatórios da Reciclagem?",
    "PromptRemovereport": "Tem certeza de que deseja remover este relatório?",
    "PromptReportswillbedeletedpermanently": "Os relatórios serão removidos permanentemente e não poderão ser restaurados.",
    "AreYouSureDelete": "Tem certeza de que deseja remover?",
    "AreYouSureRemove": "Tem certeza de que deseja remover este relatório?",
    "LanguagePrompt_PromptConfirm": "confirme",
    "LanguagePrompt_PromptCancel": "Cancelar",
    "NAME": "LanguagePrompt"
}